import { inspectPatientPhone } from "../../../../utils/patientPhone";

/**
 * "Is Phone Number" — the format rule a patient-facing input can carry.
 *
 * ⛔ The verdict is inspectPatientPhone()'s, never a second copy of the rule. That module
 * mirrors the send endpoint (main-service/task.js) exactly: 10 digits, or 11 starting with
 * a 1, any punctuation tolerated. Deliberately NOT google-libphonenumber — see the header
 * of src/utils/patientPhone.js for the two production incidents that came from being
 * stricter than the backend. A number this rule accepts is exactly a number Teamio can
 * text, which is the whole point of validating it on the form.
 *
 * BLANK PASSES. A format rule says "if you type something, it has to look like this"; only
 * `required` says a field must be filled. An office that wants both adds both rules.
 *
 * @param {any} fieldValue
 * @return {boolean}
 */
export default function isPhoneRule(fieldValue) {
    if (fieldValue === null || fieldValue === undefined) {
        return true
    }

    const asString = String(fieldValue)
    if (asString.trim() === '') {
        return true
    }

    return inspectPatientPhone(asString).ok
}
